<template>
  <div id="creator_country_agency"  :class="isFull === 1 ? 'creator_country_agency top_information1' : ' creator_country_agency'">
    <van-nav-bar
        left-arrow
        placeholder
        fixed
        :title="$t('column.Agency_Creator')"
        @click-left="goBack"
    />
    <van-row>
        <van-col span="22" offset="1" class="creator_country_agency_seach">
          <div class="search-container">
            <div class="search-top-row">
              <div class="month-selector" @click="showMonthPicker = true">
                <van-icon name="notes-o" size="18" />
                <span class="month-text">{{ search_month }}</span>
                <van-icon name="arrow-down" />
              </div>
            </div>
            <van-col span="24" class="creator_country_agency_seach_bg">
                <!-- Middle Row: User ID and Agency UID -->
                <div class="search-inputs-row">
                <div class="search-input-wrapper">
                    <span class="input-label">{{ $t('column.user_id') }}</span>
                    <input v-model="search_user_id" type="text" :placeholder="$t('column.please_input')" />
                </div>
                <div class="search-input-wrapper">
                    <span class="input-label">{{ $t('column.agency_uid') }}</span>
                    <input v-model="search_agency_uid" type="text" :placeholder="$t('column.please_input')" />
                </div>
                </div>

                <!-- Bottom Row: Time Range and Query Button -->
                <div class="search-time-row">
                <span class="time-label">{{ $t('other.time') }}:</span>
                <div class="date-input" @click="showStartTimePicker = true">
                    <van-icon name="notes-o" v-if="!search_start_time" color="#ccc"/>
                    <span>{{ search_start_time }}</span>
                </div>
                <span class="time-separator">-</span>
                <div class="date-input" @click="showEndTimePicker = true">
                    <van-icon name="notes-o" v-if="!search_end_time" color="#ccc"/>
                    <span>{{ search_end_time }}</span>
                </div>
                <div class="query-btn" @click="onSearch">
                    <van-icon name="search" /> {{ $t('column.Query') }}
                </div>
                </div>
            </van-col>
          </div>
          <!-- Popups -->
          <van-popup v-model="showMonthPicker" position="bottom">
            <van-datetime-picker
              v-model="currentMonthDate"
              type="year-month"
              :min-date="minDate"
              :max-date="maxDate"
              @confirm="onConfirmMonth"
              @cancel="showMonthPicker = false"
            />
          </van-popup>

          <van-popup v-model="showStartTimePicker" position="bottom">
            <van-datetime-picker
              v-model="currentStartDate"
              type="date"
              :min-date="minDate"
              :max-date="maxDate"
              @confirm="onConfirmStartTime"
              @cancel="showStartTimePicker = false"
            />
          </van-popup>

          <van-popup v-model="showEndTimePicker" position="bottom">
            <van-datetime-picker
              v-model="currentEndDate"
              type="date"
              :min-date="minDate"
              :max-date="maxDate"
              @confirm="onConfirmEndTime"
              @cancel="showEndTimePicker = false"
            />
          </van-popup>
        </van-col>
      <van-col span="24" style="margin-top: 3vw;">
        <van-list
          v-model="loading"
          :finished="finished"
          :finished-text="$t('other.there_is_no_more')"
          :loading-text="$t('other.Loading')"
          @load="onLoad"
        >
          <van-cell v-for="item in list" :key="item.id">
             <van-col span="24" class="creator_country_agency_type">
                <van-col span="17" class="creator_country_agency_type_left">
                    <van-col span="24">
                        <van-col span="7" class="creator_country_agency_type_left_user_img">
                          <img :src="item.head_image ? item.head_image : require('../assets/img/avatar.png')" alt="">
                          <img src="../assets/img/sex2-3.png" class="creator_country_agency_type_left_user_sex" v-if="item.sex == 2"/>
                          <img src="../assets/img/sex1-3.png" class="creator_country_agency_type_left_user_sex" v-else/>
                        </van-col>
                        <van-col span="17">
                          <van-col span="16" class="creator_country_agency_type_left_user_name">{{item.nick_name}}</van-col>
                          <van-col span="16" class="creator_country_agency_type_left_user_id">ID:{{item.user_id}}</van-col>
                        </van-col>
                    </van-col>
                  
                </van-col>
                <van-col span="7" class="creator_country_agency_type_right">
                    <van-col span="24" class="creator_country_agency_type_right_text" @click="creator_country_user_income(item)">{{ $t('column.Revenue_records') }}</van-col>
                </van-col>
                <van-col span="23" offset="1" class="creator_country_agency_type_left_agent">{{ $t('column.Create_Agency') }}: {{ item.creator_agency_name }}({{ item.creator_agency_uid }})</van-col>
                <van-col span="23" offset="1" class="creator_country_agency_type_left_reamings">{{ $t('column.Total_Earnings') }}</van-col>
                <van-col span="23" offset="1" class="creator_country_agency_type_left_coin"><img src="../assets/img/creator/creator_country_fd.png" />{{  item.income_k }}</van-col>
             </van-col>
          </van-cell>
        </van-list>
      </van-col>
    </van-row>
  </div>
</template>

<script>
import '@/assets/css/style.css'
import axios from "axios";
import {Toast} from "vant";
import dayjs from "dayjs";

export default {
  data() {
    return {
      isFull: 0, // is_full=1 全屏显示信号栏 0 非全屏显示信号栏
      total: 0,
      invite_url: '',
      list: [],
      loading: false,
      finished: false,
      page: 1,
      search_month: dayjs().format('YYYY-MM'),
      search_user_id: '',
      search_agency_uid: '',
      search_start_time: '',
      search_end_time: '',
      showMonthPicker: false,
      showStartTimePicker: false,
      showEndTimePicker: false,
      currentMonthDate: new Date(),
      currentStartDate: new Date(),
      currentEndDate: new Date(),
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(2100, 11, 31),
    }
  },
  created() {
    this.isFull = this.$route.query.is_full == 1 ? 1 : 0 // is_full=1 显示信号栏
    this.search_agency_uid = this.$route.query.search_agency_uid ? this.$route.query.search_agency_uid : ''
    this.get_list()
  },
  methods: {
    creator_country_user_income(item){
      const token = this.$route.query.token
      this.$router.push({ path: '/creator_country_user_income', query: { token: token,is_full: this.isFull,search_user_id:item.user_id } });
    },
    onConfirmMonth(value) {
      this.search_month = dayjs(value).format('YYYY-MM');
      this.showMonthPicker = false;
    },
    onConfirmStartTime(value) {
      this.search_start_time = dayjs(value).format('YYYY-MM-DD');
      this.showStartTimePicker = false;
    },
    onConfirmEndTime(value) {
      this.search_end_time = dayjs(value).format('YYYY-MM-DD');
      this.showEndTimePicker = false;
    },
    onSearch() {
      this.page = 1;
      this.list = [];
      this.finished = false;
      this.get_list();
    },
    goBack() {
      this.$router.go(-1);
    },
    get_list(){
      this.loading = true
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=creator_country&act=create_user_list", {
        params : {
          token: token,
          date_ym: this.search_month,
          to_uid: this.search_user_id,
          agency_uid: this.search_agency_uid,
          start_time: this.search_start_time,
          end_time: this.search_end_time,
          page: this.page
        }
      }).then(res =>{
        this.loading = false;
        if (this.page === 1) {
          this.list = []
        }
        this.total = res.data.data.sum
        this.invite_url = res.data.data.invite_url
        for (let j = 0; j < res.data.data.list.length; j++) {
          this.list.push(res.data.data.list[j])
        }
        //如果列表数据条数< 0，不再触发滚动加载
        if (res.data.data.list.length <= 0) {
          this.finished = true
        }
        this.page ++
      })
    },
    onLoad() {
      // 异步更新数据
      if (this.page > 1){
        this.get_list()
      }
    },
  }
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/creator_country_user.vue